import jsonConfig from '../config.json'
const config = jsonConfig;
export const gtmId = config.GTM_CL || 'GTM-NM62MBM';
export const urlAmazon = "https://s3.amazonaws.com/";
export const statusOk = "OK";
export const statusError = "ERROR";
export const status200 = 200;
export const backgroundColor = "#701a82";
export const identityFrontUrl = config.IDENTITY_FRONT_URL || 'https://firma.id.autofact.qa/';
export const API_URL = config.REACT_APP_ENV_API_URL || "https://eskshdl1gi.execute-api.us-east-1.amazonaws.com/latest/v1/rekognition/";
export const errors = {
    CODE_NOT_FOUND: 'CODE_NOT_FOUND'
};

export function getChatbotConfig() {
  return {
    apiHttpUrl: config.CHATBOT_API_HTTP_URL || 'https://data-api-chatbot.data.qa.autofact.app',
    apiWsUrl: config.CHATBOT_API_WS_URL || 'wss://data-api-chatbot.data.qa.autofact.app/v1/ws/chat',
    apiKey: config.CHATBOT_API_KEY || '',
    authStrategy: config.CHATBOT_AUTH_STRATEGY || 'recaptcha',
    recaptchaSiteKey: config.CHATBOT_RECAPTCHA_SITE_KEY || '',
    bot: config.CHATBOT_BOT || 'soporte-firma',
    chatName: config.CHATBOT_CHAT_NAME || 'Sofía de Autofact',
    chatAvatarUrl: config.CHATBOT_AVATAR_URL || 'https://static.retail.autofact.cl/img/avatar-chatbot.png',
    headerColor: config.CHATBOT_HEADER_COLOR || '#15257a',
    footerColor: config.CHATBOT_FOOTER_COLOR || '#FFFFFF',
    floatingButtonColor: config.CHATBOT_FLOATING_BUTTON_COLOR || 'rgba(0, 76, 198, 0.8)',
    sendButtonColor: config.CHATBOT_SEND_BUTTON_COLOR || '#004cc6',
    cornerSpace: Number.parseInt(config.CHATBOT_CORNER_SPACE || '10', 10),
    bottomSpace: Number.parseInt(config.CHATBOT_BOTTOM_SPACE || '30', 10),
    enabled: config.CHATBOT_ENABLED !== 'false',
  };
}

export function getGrowthbookConfig() {
  return {
    apiHost: config.GROWTHBOOK_API_URL || 'https://growth-proxy.autofact.com',
    fallback: config.GROWTHBOOK_FALLBACK === 'true',
    clientKey: config.GROWTHBOOK_CLIENT_KEY || '',
    gaClientIdTimeoutMs: Number(config.GROWTHBOOK_GA_CLIENT_ID_TIMEOUT_MS) || 2000,
    featureKey: config.GROWTHBOOK_FEATURE_KEY || 'sign-liveness-chatbot-data',
  };
}